<template>
  <div id="app" :class="appClasses">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import '@/css/main.scss'
import '@/css/theme.scss'

export default {
  name: "App",
  computed: {
    appClasses () {
      const designType = this.$store.getters.domainConfig?.designType || 1;
      const themeClass = designType === 2 ? 'theme-orange' : '';
      const deviceType = this.$store.getters.deviceType;
      const deviceClass = deviceType === 'mobile' || deviceType === 'tablet' ? 'is_mobile i_m' : 'is_pc i_pc';
      return `${deviceClass} ${themeClass}`;
    }
  },
  created () {
    // SSR 环境：使用服务端上下文中的设备类型
    // 客户端水合阶段必须保持 window.__INITIAL_STATE__.deviceType 不变，防止 SSR/CSR v-if 节点不一致引发 HierarchyRequestError
    if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
      this.$store.commit('setDeviceType', this.$ssrContext.device);
    } else if (typeof window === 'undefined' || !window.__INITIAL_STATE__) {
      const deviceType = this.detectDeviceType();
      this.$store.commit('setDeviceType', deviceType);
    }
  },
  mounted () {
    // 调试模式检测（水合完成后再同步）
    const debug = this.$global.GetQueryString('db');
    if (debug) {
      this.$store.commit('setDebug', true);
    }

    // 水合完成后再同步客户端真实设备类型（兼容 CDN 缓存跨设备 HTML 或窄视口窗口的场景）
    const deviceType = this.detectDeviceType();
    if (deviceType !== this.$store.getters.deviceType) {
      this.$store.commit('setDeviceType', deviceType);
    }
    this.syncBodyDeviceClass(deviceType);

    this.fetchGlossary();
    this.fetchSubprimeLendingInstitutions();
  },
  methods: {
    syncBodyDeviceClass (deviceType) {
      if (typeof document === 'undefined' || !document.body) return;
      const isMobileOrTablet = deviceType === 'mobile' || deviceType === 'tablet';
      document.body.classList.toggle('is_mobile', isMobileOrTablet);
      document.body.classList.toggle('i_m', isMobileOrTablet);
      document.body.classList.toggle('is_pc', !isMobileOrTablet);
      document.body.classList.toggle('i_pc', !isMobileOrTablet);
    },
    fetchGlossary () {
      this.$global.server.postAPI({
        method: 'get',
        params: {
          pageSize: '50',
          pageNum: '1',
        },
        url: '/car/Loans/indexPage',
      })
        .then(response => {
          if (response && response.data && response.data.list) {
            // 将接口返回的贷款机构列表存储到vuex
            this.$store.commit('setGlossary', response.data.list);
            console.log('汽车贷款机构列表获取成功:', response.data);
          }
        })
        .catch(error => {
          console.error('获取汽车贷款机构列表失败:', error);
        });
    },
    fetchSubprimeLendingInstitutions () {
      this.$global.server.postAPI({
        method: 'get',
        params: {
          pageSize: '20',
          pageNum: '1',
        },
        url: '/car/Loans/subprimeLendingInstitutionsList',
      })
        .then(response => {
          if (response && response.data) {
            // 将接口返回的信用较差贷款机构列表存储到vuex
            this.$store.commit('setSubprimeLendingInstitutions', response.data);
            console.log('信用较差贷款机构列表获取成功:', response.data);
          }
        })
        .catch(error => {
          console.error('获取信用较差贷款机构列表失败:', error);
        });
    },
    detectDeviceType () {
      try {
        // SSR 环境检测
        if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
          return this.$ssrContext.device;
        }

        // 客户端环境检测
        if (typeof window !== 'undefined') {
          const userAgent = navigator.userAgent.toLowerCase();

          // 平板设备检测
          const isTablet = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
          if (isTablet) return 'tablet';

          // 移动设备检测
          const isMobile = /mobile|android|iphone|phone|webos|ipod|blackberry|windows phone/i.test(userAgent);
          if (isMobile) return 'mobile';

          // 窄视口窗口辅助判断（如 crossdevice 桌面 UA + 390px 视口）
          if (window.innerWidth > 0 && window.innerWidth < 768) return 'mobile';
        }

        return 'desktop';
      } catch (error) {
        console.warn('设备类型检测失败:', error);
        return 'desktop'; // 发生错误时返回默认值
      }
    },

  }
};
</script>
